import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { LogOut } from 'lucide-react';

export default function DashboardLayout({ brand, subtitle, navItems, user, onLogout, getTitle, children }) {
  return (
    <div className="min-h-screen bg-[#08080a] text-white flex">
      <aside className="w-64 shrink-0 border-r border-white/10 bg-[#0a0a0f] flex flex-col fixed h-full z-10">
        <div className="p-5 border-b border-white/10">
          <div className="text-lg font-semibold text-[#d42b92]">{brand}</div>
          {subtitle && <div className="text-xs text-white/40 mt-0.5">{subtitle}</div>}
        </div>
        <nav className="flex-1 p-3 space-y-0.5 overflow-y-auto">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.end}
              className={({ isActive }) =>
                `flex items-center gap-2.5 w-full px-3 py-2.5 rounded-lg text-sm transition-colors ${
                  isActive
                    ? 'bg-[#d42b92]/20 text-[#ff8ec5] border border-[#d42b92]/30'
                    : 'text-white/60 hover:bg-white/5 hover:text-white border border-transparent'
                }`
              }
            >
              {item.icon && <item.icon className="w-4 h-4 shrink-0" />}
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10">
          <div className="text-xs text-white/40 mb-2 truncate">{user?.name}</div>
          <div className="text-[10px] text-white/30 mb-3 truncate">{user?.email}</div>
          <button
            onClick={onLogout}
            className="flex items-center gap-2 text-sm text-white/60 hover:text-white transition-colors"
          >
            <LogOut className="w-4 h-4" /> Sign Out
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-64 overflow-y-auto min-h-screen">
        <div className="p-8">
          {getTitle && <h1 className="text-2xl font-semibold mb-6">{getTitle()}</h1>}
          {children || <Outlet />}
        </div>
      </main>
    </div>
  );
}
